<template>
  <div class="sound-root">
    <SinglePlayer :soundUrl="currentItem.tts_url"></SinglePlayer>

    <div
      v-for="(item, index) in pinyinList"
      :key="item.id"
      class="pinyin-item"
      :class="getPinyinBc(index)"
    >
      {{ item }}
    </div>
  </div>
</template>
<script>
import SinglePlayer from './singlePlayer.vue'
import { getToneNum } from '@/utils/pinyinTone'
export default {
  components: {
    SinglePlayer,
  },
  props: {
    currentItem: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    pinyinList() {
      if (this.currentItem.pinyin) {
        return this.currentItem.pinyin.split(' ')
      }
      return []
    },
  },
  data() {
    return {
      loaded: true,
      pinyinNumList: [],
    }
  },
  mounted() {
    this.pinyinNumList = this.currentItem.pinyin_num.split(' ')
  },
  methods: {
    getPinyinBc(index) {
      if (this.pinyinNumList[index]) {
        let num = getToneNum(this.pinyinNumList[index])
        return 'tone-' + num
      }

      return 'tone-1'
    },
  },
}
</script>
<style lang="scss" scoped>
.sound-root {
  display: flex;
  align-items: center;
  justify-content: center;
}
.pinyin-item {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  margin: 4px 0 4px 8px;
  font-size: 18px;
  font-weight: 700;
  border-radius: 6px;
  border: none;
  color: #2c2f46;
}
.tone-1 {
  background: #fee7e2;
}
.tone-2 {
  background: #fef4dd;
}
.tone-3 {
  background: #dbf4e3;
}
.tone-4 {
  background: #d9effa;
}
.tone-5 {
  background: #ebebed;
}
</style>
